import { render, staticRenderFns } from "./week.vue?vue&type=template&id=4969a1b9&lang=html"
import script from "./week.vue?vue&type=script&lang=js"
export * from "./week.vue?vue&type=script&lang=js"
import style0 from "./week.vue?vue&type=style&index=0&id=4969a1b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports